import { useEffect } from "react";
import moment from "moment";
import axios from "axios";

import { STATE_DATE_FORMAT } from "../lib/data";

export const useRate = ({
    actualRates,
    activeRates,
    pickedRate,
    roomType,
    month,
    rateRequestParams,
    date_start,
    date_end,
    initAction,
    setPickedRate,
    setRulesForChange,
    defaultRules,
    formulasPath,
    setAsignRules,
    startLoading,
}) => {
    useEffect(() => {
        startLoading();
        const initAsync = async () => {
            const getRateChangeRules = async () => {
                try {
                    const response = await axios.get(formulasPath, {
                        params: {
                            rate_id: pickedRate.id,
                            room_type_id: roomType.id,
                        },
                    });
                    return response.data;
                } catch (e) {
                    alert(e.message);
                }
            };

            if (
                !actualRates.includes(pickedRate) &&
                !pickedRate?.base_rate_for_bar
            ) {
                let rateToSet;

                if (actualRates.length > 0) {
                    rateToSet = actualRates[0];
                    alert(`Тариф изменен на ${rateToSet.name}`);
                } else if (actualRates.length <= 0) {
                    rateToSet = activeRates[0];
                }
                setPickedRate(rateToSet);
            }

            const dateStartMoment = moment(date_start, STATE_DATE_FORMAT);
            const dateEndMoment = moment(date_end, STATE_DATE_FORMAT);
            const pickedRateDateEnd = moment(
                pickedRate.date_end,
                STATE_DATE_FORMAT,
            );
            const newStartDate = dateStartMoment.isBefore(moment())
                ? moment().add(1, "d").format(STATE_DATE_FORMAT)
                : date_start;

            let newEndDate = moment(newStartDate, STATE_DATE_FORMAT).isSame(
                dateEndMoment,
            )
                ? dateEndMoment.add(1, "d").format(STATE_DATE_FORMAT)
                : date_end;

            if (
                moment(newEndDate, STATE_DATE_FORMAT).isAfter(pickedRateDateEnd)
            ) {
                newEndDate = pickedRateDateEnd.format(STATE_DATE_FORMAT);
            }

            initAction(rateRequestParams);

            const savedRules = await getRateChangeRules();

            setAsignRules(
                returnRules(defaultRules, {
                    rate_id: pickedRate.id,
                    room_type_id: roomType.id,
                    date_start: newStartDate,
                    date_end: newEndDate,
                }),
            );

            setRulesForChange((prevState) => {
                if (
                    typeof savedRules === "object" &&
                    Object.keys(savedRules).length > 0
                ) {
                    const formatedRules = formatSavedRulesForLayout(
                        savedRules,
                        prevState,
                    );

                    return returnRules(formatedRules, {
                        rate_id: pickedRate.id,
                        room_type_id: roomType.id,
                        date_start: newStartDate,
                        date_end: newEndDate,
                    });
                }

                return returnRules(defaultRules, {
                    rate_id: pickedRate.id,
                    room_type_id: roomType.id,
                    date_start: newStartDate,
                    date_end: newEndDate,
                });
            });
        };

        initAsync();
    }, [month, pickedRate, roomType, date_end]);
};

const formatSavedRulesForLayout = (fromServer, curRules) => ({
    ...curRules,
    rate_id: fromServer.rate_id,
    room_type_id: fromServer.room_type_id,
    data: fromServer.formulas.map((formula) => formula),
});

const returnRules = (
    rules,
    { rate_id, room_type_id, date_start, date_end },
) => ({
    ...rules,
    rate_id,
    room_type_id,
    date_start,
    date_end,
});
